<div class="entity-workspace-header">
	<div class="header-row">
		<entity-title
			[name]="config().data?.name"
			[entityType]="entityIcon()"
			(nameChanged)="updateData($event)"
		/>
		<au-close-button (closeCallback)="closeSidebar()" />
	</div>
	<div class="info-actions">
		<div class="info">
			@if (statuses()) {
				<entity-status-text [displayedStatus]="config().data.status" />
			}
			<div class="dot"></div>
			<div>
				<locations-chip
					[selectedLocations]="config().data.locations"
					[clickable]="true"
					(locationsChanged)="updateData({ locations: $event })"
				/>
			</div>
		</div>

		<entity-workspace-actions
			[config]="config()"
			[locationAncestry]="locationAncestry()"
			(dataChanged)="updateData($event)"
		/>
	</div>
	<mat-tab-group class="fill-tab-height">
		<mat-tab [label]="'information' | translate">
			<information-tab
				class="tab-padding"
				(updateData)="updateData($event)"
				[config]="config()"
			/>
		</mat-tab>

		<mat-tab [label]="'activity' | translate">
			<activity-tab (updateData)="updateData($event)" [config]="config()" />
		</mat-tab>

		<mat-tab [label]="'tasks' | translate">
			<tasks-tab
				class="tab-padding"
				[data]="config().data"
				(updateData)="updateData($event)"
			/>
		</mat-tab>

		<mat-tab [label]="'assets' | translate">
			<assets-tab
				[assets]="config().data.assets"
				[workorderPk]="config().data.pk"
				(updateData)="updateData($event)"
			/>
		</mat-tab>

		<mat-tab [label]="'files' | translate">
			<files-tab
				[workorder]="config().data"
				(filesChanged)="updateData({ files: $event })"
			/>
		</mat-tab>
	</mat-tab-group>
</div>
